import React, { useRef, useState } from "react";

import { MDBInput } from "mdb-react-ui-kit";

import Constants, {
  ROLE_LIST,
  ROLE_LIST_PAGING,
  VIEW_ROLE,
  INSERT_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
  VIEW_MENUS,
  ALL_CLIENT_LIST,
  CLIENT_API,
  ROLE_SUPER_ADMIN_NAME
} from "../../../src/constants";
import Select from "react-select";
import ReactBSAlert from "react-bootstrap-sweetalert";
// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
  CustomInput,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";

import axios from "axios";
import NotificationAlert from "react-notification-alert";
import moment from "moment";

import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import apiService from "../../variables/apiService";
let clientsList = [];



const Roles = () => {
  let records = [];
  const [modalClassic, setModalClassic] = React.useState(false);
  const [menuList, setMenuList] = React.useState([]);
  const checkItems = React.useRef([]);
  const [role, setRole] = React.useState("");
  const [roleList, setRoleList] = React.useState([]);
  const [client, setClient] = React.useState([]);

  const [currentPage, setCurrentPage] = React.useState(1);
  const [roleData, setRoleData] = React.useState([]);
  const [validation, setValidation] = React.useState({});
  const [error,setError]= useState();
  const [isActive, setIsActive] = React.useState(false);

  const [uids, setUids] = React.useState([]);

  const [updateId, setUpdateId] = React.useState(0);

  const [isLoading, setIsLoading] = React.useState(true);

  const notificationAlertRef = React.useRef(null);

  const[filterList,setFilterLst] = useState([]);
  const [alert, setAlert] = React.useState(null);

  let userObj = localStorage.getItem("user");
  let user = JSON.parse(userObj);
  //const isActive =  React.useRef(true)
  const toggleModalClassic = () => {
    setModalClassic(!modalClassic);
    setUids([]);
    setRole("");
    setClient([])
  };

  React.useEffect(() => {
    user?.role!==ROLE_SUPER_ADMIN_NAME?fetchClientbyid(user?.client):getClients();
    getMenuList();
    getUserRoles(1);
   // getUserRolesList(user.client);
  }, []);

  const getUserRoles = async (pageNo) => {
    setCurrentPage(pageNo);

    await apiService
      .getData(ROLE_LIST_PAGING + "?page=" + pageNo+"&client_id="+user.client)
      .then((res) => {setRoleList(res.data);setIsLoading(false);  setFilterLst(res.data)})
      .catch((err) => {console.log(err);
        let options = {};
          options = {
            place: "tr",
            message: err?.response?.data?.message,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
      });
  };

  const getUserRolesList = async (client) => {
    await apiService
      .getData(ROLE_LIST+'?client_id='+client)
      .then((res) => {
        res?.data?.message?.length>0&&setRoleData(res?.data?.message)
      })
      .catch((err) => console.log(err));
  };

  const getMenuList = async () => {
    var userObj = localStorage.getItem("user");
    var user = JSON.parse(userObj);
    await apiService
      .postData(VIEW_MENUS, {
        id:  user.user_id.toString(),
        
      })
      .then((data) => {
        setMenuList(data.data.menus);
      })
      .catch((err) => console.log(err));
  };

  const isCheckedMenu = (id) => {
    return checkItems.current.includes(id);
  };
  const isCheckedMenus = (id) => {
   
    let a = uids.includes(id);
    if (a) {
      toggle(id);
    }
    return a;
  };

  const toggle = (id) => {
    if (isCheckedMenu(id)) {
      const index = records.indexOf(id);
      records.splice(index, 1);
    } else {
      records.push(id);
    }
    console.log(records);
    checkItems.current = records;
  };

  const changeRole = (e) => {
   
    if(!client?.value){
      setValidation({
        name: " Please Select Client ",
      });
    }else{
     
    let a = roleData?.find(
      (item, id) => item?.role?.toLowerCase() == e?.target?.value?.toLowerCase()
    );
console.log();
    if (a) {
      setValidation({
        name: e.target.value + " Already Exist",
      });
    } else {
      
      setValidation({});
    }

    setRole(e.target.value);
  }
  };

  const validate=()=>{
    const error={}
    const onlylettersRegex =/^[a-zA-Z ]+$/;
    if(!role){
      error.role="Role Required"
    }else if(role.length<2){
      error.role="Name Too Short"
    }
    // else if(!(role.match(onlylettersRegex))&&updateId==0){
    //   error.role="Please Enter Valid Name"
    // }
   
    if(checkItems.current.length==0){
      error.role="Select at least one menu"
    }
    
    return error;
  }

  const fetchClientbyid = async (id) => {
    
    setIsLoading(true)
    clientsList = [];
   
    if (id) {
      apiService
        .postData(CLIENT_API, { id: id })
        .then((res) => {
          setIsLoading(false)
          let clientObj = res?.data[0];
          res?.data?.map((item)=>{
            clientsList.push({ value: item.id, label: item.company_name})
          })
         
          setClient({ value: clientObj.id, label: clientObj.company_name})

        })
        .catch((e) => {console.log("---",e);
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
        });
    }
    
  };
  const getClients=async()=>{
    setIsLoading(true)
    clientsList = [];
    await apiService.getData(`${ALL_CLIENT_LIST}?client_id=${user?.client}`).then(res=>{
      setIsLoading(false)
      res?.data?.data?.map(item=> clientsList.push({ value: item.id, label: item.company_name}))
    }).catch(err=>{
      let options = {};
      options = {
        place: "tr",
        message: "Unable fetch records",
        type: "warning",
        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
    })
}
  const saveRole = () => {
    const userObj = localStorage.getItem("user");
    const user = JSON.parse(userObj);
    const isvalid = validate()
    setError(isvalid)

   

    if(Object.keys(isvalid).length===0){
    if (uids.length > 0) {
     console.log("current_items==",records);
      apiService
        .postData(UPDATE_ROLE, {
          id:updateId.toString(),
          role: role,
          menuid: checkItems.current,
          client_id:client?.value||user?.client,
         // createdby: "admin",
         trolestatus:`${!isActive}`
        })
        .then((data) => {
          setModalClassic(false);
          let options = {};
          options = {
            place: "tr",
            message: "Updated Successfully",
            type: "success",

            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
          getUserRoles(1);
          setClient([])
        })
        .catch((err) => console.log(err));
    } else {
      if(checkItems.current.length>0&& role){
        

      
      apiService
        .postData(INSERT_ROLE, {
          role: role,
          menuid: checkItems.current,
          client_id:client?.value||user?.client,
          createdby:  "admin",
          trolestatus:`${!isActive}`
        })
        .then((data) => {
          setModalClassic(false);
          let options = {};
          options = {
            place: "tr",
            message: "Saved Successfully",
            type: "success",

            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
          getUserRoles(1);
          setClient([])

        })
        .catch((err) => console.log(err));
      }
    }
  }
  };

  // const PagingComponent = () => {
  //   return (
  //     <>
  //       {(() => {
  //         let paging = [];
  //         paging.push(
  //           <PaginationItem>
  //             <PaginationLink
  //               aria-label="Previous"
                
  //               onClick={(e) =>
  //                 currentPage > 1 ? getUserRoles(currentPage - 1) : ""
  //               }
  //             >
  //               <span aria-hidden={true}>
  //                 <i
  //                   aria-hidden={true}
  //                   className="tim-icons icon-double-left"
  //                 />
  //               </span>
  //             </PaginationLink>
  //           </PaginationItem>
  //         );
  //         for (let i = 1; i <= roleList.numOfPages; i++) {
  //           paging.push(
  //             <PaginationItem className={currentPage == i && "active"}>
  //               <PaginationLink onClick={(e) => getUserRoles(i)}>
  //                 {i}
  //               </PaginationLink>
  //             </PaginationItem>
  //           );
  //         }
  //         paging.push(
  //           <PaginationItem>
  //             <PaginationLink
  //               aria-label="Next"
  //               href="#pablo"
  //               onClick={(e) =>
  //                 currentPage != roleList.numOfPages
  //                   ? getUserRoles(currentPage + 1)
  //                   : ""
  //               }
  //             >
  //               <span aria-hidden={true}>
  //                 <i
  //                   aria-hidden={true}
  //                   className="tim-icons icon-double-right"
  //                 />
  //               </span>
  //             </PaginationLink>
  //           </PaginationItem>
  //         );
  //         return paging;
  //       })()}
  //     </>
  //   );
  // };

  const editRole = async (name,id) => {
  
    await apiService
      .postData(VIEW_ROLE, { id: id.toString() })
      .then((res) => {
        setUids(res.data.mids);
        setModalClassic(true);
        //client_id
        const slctdclient = clientsList.filter(item=>item.value==res?.data?.client_id)
       
        setClient({ value: slctdclient[0]?.value, label: slctdclient[0]?.label})
        setRole(name);
        setUpdateId(id);
        res.data.trolestatus==="true"?setIsActive(false):setIsActive(true)
      })
      .catch((e) => console.log(e));
  };

  const confirmdeleteRole = (id) =>{
    setAlert(<ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => deleteRole(id)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You want to remove role ?
      </ReactBSAlert>
      );
  }
  const deleteRole = (id)=>{
   
    apiService.postData(DELETE_ROLE,{id:id.toString()}).then(res=>{
      let options = {};
      options = {
        place: "tr",
        message: "Deleted Successfully",
        type: "success",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
      getUserRoles(1);
      setAlert(null)
    }).catch(e => console.log(e));
   
  }

  const filterData = (e) =>{
    let filter = e.target.value;
     let filterdata = filterList?.message.filter((item,index)=>{
      return (moment(item.createdat).format('DD-MM-YYYY').toString().includes(filter)
      ||item.role.toString().includes(filter)
      ||item.createdby.toLowerCase().includes(filter.toLowerCase())
      
      )})
      setRoleList({
      message: filterdata,
      numOfPages:filterList.numOfPages
    })
    
    }

  return (
    <>
    <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
           {alert}
      <div className="content pd-0 ">
        <Row className="Roles">
          <Card>
            <CardBody className="tableheightwf">
              <NotificationAlert ref={notificationAlertRef} />
              <Col sm="12">
                <Row>
                  <Col sm="9">
                    <h4 className="add-content" onClick={toggleModalClassic}>
                      <Button
                        className="btn btn-icon btn-link-add btn-sm mr-2"
                        
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </Button>
                      Add Role
                    </h4>
                  </Col>
                  {/* <Col sm="3" className="pull-right">
                    <MDBInput label="Search" type="text" onChange={(e)=>filterData(e)}/>
                  </Col> */}
                </Row>
              </Col>
              <Col sm="12">
                <Row>
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>S.no</th>
                        <th>Roles</th>
                        <th>Client</th>
                        <th>Created By</th>
                        <th>Created Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                       
                      </tr>
                    </thead>

                    <tbody>
                      
                      {roleList?.message?.map((item, index) => {
                        
                        return (
                          <React.Fragment key={index}>
                           {
                            roleList?.message?.length>0?
                            <tr>
                            <td>{++index}</td>
                            <td>{item.role}</td>
                            <td>{item?.company_name}</td>
                            <td>{item.createdby}</td>

                            <td>{moment(item.createdat).format('DD-MM-YYYY')}</td>
                            <td>
                            {item.trolestatus==="true"?<Badge className="badge badge-warning" color="success">
                            Active
                              </Badge>: <span className="badge badge-warning">In-active</span>}
                           
                              
                            </td>
                            <td>
                              <a to="" className="text-info mr-2">
                                <i
                                  className="tim-icons icon-pencil"
                                  onClick={() => editRole(item.role,item.id)}
                                ></i>
                              </a>
                              <a to="" className="text-warning ml-2">
                                <i
                                  className="tim-icons icon-trash-simple"
                                  onClick={() => confirmdeleteRole(item.id)}
                                ></i>
                              </a>
                            </td>
                            
                          </tr>:
                          <tr >
                            <td>No Records Found</td>
                          </tr>
                           }
                           
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </Row>
              </Col>
            </CardBody>
            {
              roleList.numOfPages>0&&
                <div style={{marginLeft:"auto",padding:"8px"}}>
                <ResponsivePagination
              current={currentPage}
              total={roleList?.numOfPages}
              onPageChange={(newPage )=>{getUserRoles(newPage)}}
            />
            </div>
        }
          </Card>

          <Modal
            isOpen={modalClassic}
            toggle={toggleModalClassic}
            className="roles-popup"
          >
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={toggleModalClassic}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h3 className="title title-up multicolortext">
                Select Role Based Menu Items
              </h3>
            </div>
            <ModalBody className="modelbody menu-list-icons">
              <Col sm="12">
                <Row>
                 
                  <Col sm="3" className="mb-4">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Select Client"
                        name="client"
                        value={client}
                        onChange={(value) => {
                          setClient(value);
                          getUserRolesList(value?.value);
                        }}
                        options={clientsList}
                      />
                      <span style={{color:"red"}}>{error?.client}</span>
                    </Col>
                    <Col sm="3" className="mb-2">
                  {error?.role&&<span style={{color:"red"}}>{error.role}</span>}
                    <MDBInput
                      label="Role Name"
                      type="text"
                      value={role}
                      onChange={(e) => changeRole(e)}
                    />
                    {validation?.name && (
                      <span className="ml-n2" style={{ color: "red" }}>
                        {validation.name}
                      </span>
                    )}
                  </Col>
                  <Col sm="3" className="mb-2 mt-2">
                    <div className="d-flex align-items-center">
                      <span className="mr-2">In-active</span>
                      <CustomInput
                        type="switch"
                        id="switch-5"
                        className="mt-n4"
                        checked={!isActive}
                        //checked={isActive.current}
                        onChange={() => setIsActive(!isActive)}
                      />
                      <span className="ml-n2">Active</span>
                    </div>
                  </Col>
                  <Col sm="3">
                    <Button type="submit" className="btn btn-icon btn-primary">
                      <i
                        className="tim-icons icon-double-right"
                        onClick={() => saveRole()}
                      ></i>
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col className="scroll-height-350">
                <Table responsive striped>
                  <tbody>
                    {menuList.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td colSpan={2}>
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    value={item.id}
                                    defaultChecked={
                                      isCheckedMenus(item.id) ? true : false
                                    }
                                    onClick={() => toggle(item.id)}
                                  />
                                  <span className="form-check-sign" />
                                  <img alt="image" src={item.icon} />
                                  {item.displayname}
                                 
                                </Label>
                              </FormGroup>
                            </td>
                            <td>
                              {item.submenu.map((data, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <ul>
                                      <li>
                                        <FormGroup check>
                                          <Label check>
                                            <Input
                                              type="checkbox"
                                              value={data.id}
                                              defaultChecked={
                                                isCheckedMenus(data.id)
                                                  ? true
                                                  : false
                                              }
                                              onClick={() => {
                                                toggle(data.id);
                                              }}
                                            />

                                            <span className="form-check-sign" />
                                            <img alt="image" src={data.icon} />
                                            <b>{data.displayname}</b>
                                           
                                          </Label>
                                        </FormGroup>
                                        <ol>
                                          {data?.subsubmenu?.map((obj, i) => {
                                            return (
                                              <React.Fragment key={i}>
                                                <li>
                                                  <FormGroup check>
                                                    <Label check>
                                                      <Input
                                                        type="checkbox"
                                                        value={obj.id}
                                                        defaultChecked={
                                                          isCheckedMenus(obj.id)
                                                            ? true
                                                            : false
                                                        }
                                                        onClick={() =>
                                                          toggle(obj.id)
                                                        }
                                                      />
                                                      <span className="form-check-sign" />
                                                      <img
                                                        alt="image"
                                                        src={obj.icon}
                                                      />
                                                      {obj.displayname}
                                                      
                                                    </Label>
                                                  </FormGroup>
                                                </li>
                                              </React.Fragment>
                                            );
                                          })}
                                        </ol>
                                      </li>
                                    </ul>
                                  </React.Fragment>
                                );
                              })}
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </ModalBody>
          </Modal>
        </Row>
      </div>
    </>
  );
};

export default Roles;
